<template>
  <div class="carteira-vacinacao-form">
    <modal-data-form
      :show-modal="store.showModalDataForm"
      :title="title"
      :on-save="onSave"
    >
      <field-group-form :group-label="$t('Carteira')">
        <v-row>
          <v-col class="ma-0 py-0 pt-6" cols="12">
            <validation-provider
              v-slot="{ errors }"
              name="carteiraVacinacao"
              rules="size:20480"
            >
              <v-file-input
                v-model="fields.carteiraVacinacao"
                chips
                filled
                prepend-icon="mdi-file-upload-outline"
                :error-messages="errors"
                :show-size="true"
                :truncate-length="$vuetify.breakpoint.xsOnly ? 20 : 50"
                :placeholder="$t('click_para_inserir_foto_pdf')"
                accept="image/*, .pdf"
              />
            </validation-provider>
          </v-col>
        </v-row>
      </field-group-form>
      <field-group-form :group-label="$t('Carteira_Convenio')">
        <v-row>
          <v-col class="ma-0 py-0 pt-6" cols="12">
            <validation-provider
              v-slot="{ errors }"
              name="carteiraConvenio"
              rules="size:20480"
            >
              <v-file-input
                v-model="fields.carteiraConvenio"
                chips
                filled
                prepend-icon="mdi-file-upload-outline"
                :error-messages="errors"
                :show-size="true"
                :truncate-length="$vuetify.breakpoint.xsOnly ? 20 : 50"
                :placeholder="$t('click_para_inserir_foto_pdf')"
                accept="image/*, .pdf"
              />
            </validation-provider>
          </v-col>
        </v-row>
      </field-group-form>
      <field-group-form :group-label="$t('Carteira_Doador')">
        <v-row>
          <v-col class="ma-0 py-0 pt-6" cols="12">
            <validation-provider
              v-slot="{ errors }"
              name="carteiraDoador"
              rules="size:20480"
            >
              <v-file-input
                v-model="fields.carteiraDoador"
                chips
                filled
                prepend-icon="mdi-file-upload-outline"
                :error-messages="errors"
                :show-size="true"
                :truncate-length="$vuetify.breakpoint.xsOnly ? 20 : 50"
                :placeholder="$t('click_para_inserir_foto_pdf')"
                accept="image/*, .pdf"
              />
            </validation-provider>
          </v-col>
        </v-row>
      </field-group-form>
      <field-group-form :group-label="$t('Carteira_Link')">
        <v-row>
          <v-col class="ma-0 py-0 pt-6" cols="12">
            <validation-provider v-slot="{ errors }" name="carteiraLink">
              <v-text-field
                v-model="fields.carteiraLink"
                filled
                prepend-icon="mdi-link-variant"
                :error-messages="errors"
                :truncate-length="$vuetify.breakpoint.xsOnly ? 20 : 50"
                :placeholder="$t('cole_digite_um_link')"
              />
            </validation-provider>
          </v-col>
        </v-row>
      </field-group-form>
    </modal-data-form>
  </div>
</template>

<script>
import ModalDataForm from "@/components/forms/modal-data-form";
import FieldGroupForm from "@/components/forms/field-group-form";
import { extend, ValidationProvider } from "vee-validate";
import { size } from "vee-validate/dist/rules";
import { updateData, uploadFile } from "@/services";

export default {
  props: {
    title: {
      type: String,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  components: { FieldGroupForm, ModalDataForm, ValidationProvider },
  data: () => ({
    fields: {
      carteiraVacinacao: null,
      carteiraConvenio: null,
      carteiraDoador: null,
      carteiraLink: null,
    },
  }),
  watch: {
    "store.showModalDataForm"(nextValue) {
      if (nextValue) {
        this.fields.carteiraVacinacao = null;
        this.fields.carteiraConvenio = null;
        this.fields.carteiraDoador = null;
        this.fields.carteiraLink = null;
      }
    },
  },
  computed: {
    store() {
      return this.$store.state;
    },
  },
  beforeMount() {
    this.$store.commit("setShowModalDataForm", false);

    extend("size", {
      ...size,
      message: this.$t("arquivo_menos_de_20MB"),
    });
  },
  methods: {
    onSave() {
      this.uploadCarteiraVacinacao(this.data).then((data) =>
        this.uploadCarteiraConvenio(data).then((data) =>
          this.uploadCarteiraDoador(data).then((data) =>
            this.updateLink(data, this.fields).then((data) =>
              updateData(this, "tagFuncionario", data)
            )
          )
        )
      );
    },
    uploadCarteiraVacinacao(fields) {
      return new Promise((resolve) => {
        if (
          this.fields.carteiraVacinacao &&
          this.fields.carteiraVacinacao.constructor.name === "File"
        ) {
          uploadFile(
            this,
            "tagFuncionario",
            this.fields.carteiraVacinacao,
            "carteiraVacinacao",
            (data) => resolve({ ...fields, ...data })
          );
        } else {
          resolve(fields);
        }
      });
    },
    uploadCarteiraConvenio(fields) {
      return new Promise((resolve) => {
        if (
          this.fields.carteiraConvenio &&
          this.fields.carteiraConvenio.constructor.name === "File"
        ) {
          uploadFile(
            this,
            "tagFuncionario",
            this.fields.carteiraConvenio,
            "carteiraConvenio",
            (data) => resolve({ ...fields, ...data })
          );
        } else {
          resolve(fields);
        }
      });
    },
    uploadCarteiraDoador(fields) {
      return new Promise((resolve) => {
        if (
          this.fields.carteiraDoador &&
          this.fields.carteiraDoador.constructor.name === "File"
        ) {
          uploadFile(
            this,
            "tagFuncionario",
            this.fields.carteiraDoador,
            "carteiraDoador",
            (data) => resolve({ ...fields, ...data })
          );
        } else {
          resolve(fields);
        }
      });
    },
    updateLink(data, fields) {
      return new Promise((resolve) => {
        data.carteiraLink = fields.carteiraLink
          ? fields.carteiraLink
          : data.carteiraLink;
        resolve(data);
      });
    },
  },
};
</script>

<style scoped></style>
